import DoubtsDashboard from "../components/doubts-dashboard/Dashboard/Dashboard";

export const DoubtsPage1 = () => {
  return <DoubtsDashboard />;
};
